import type { GamePageEvent } from "@/context/AnalyticsProvider/gamePage";

export interface GPOnboardingStepProps {
  onNext: (increment?: number) => void;
  isVisible: boolean;
  track: (event: GamePageEvent) => void;
}

export enum GPOnboardingStep {
  LOGIN = "login",
  BRONZE_REWARD_ACHIEVED = "bronze-reward-achieved",
  LINK_STEAM = "link-steam",
  SILVER_REWARD_ACHIEVED = "silver-reward-achieved",
  WISHLIST_STEAM = "wishlist-steam",
  WISHLIST_STEAM_VERIFY = "wishlist-steam-verify",
  FOLLOW_ON_X = "follow-on-x",
  GOLD_REWARD_ACHIEVED = "gold-reward-achieved",
}

export enum GPOnboardingType {
  EXTRINSIC = "25-11-27_ExtrinsicRewards_Acq-Broad_8-Ball_Leads_All-Placements",
  HYBRID = "25-11-27_HybridRewards_Acq-Broad_8-Ball_Leads_All-Placements",
  INGAME = "25-11-27_In-GameRewards_Acq-Broad_8-Ball_Leads_All-Placements",
  NO_PROMPT = "25-11-27_NoPrompt_Acq-Broad_8-Ball_Leads_All-Placements",
}
